<template>
  <flex-row>
    <template v-if="showTime">
      <flex-cell shrink class="first">
        <native-select
          @touched="touched"
          v-model="hour"
          :field="{ minimum: 1, maximum: 1, options: hourOptions }"
        >
          <div class="date-section">
            {{ displayHour }}
            <ux-icon right icon="fa-angle-down" />
          </div>
        </native-select>
        <!-- <div class="custom-select">
                <select v-model="hour">
                    <option :value="hour.value" v-for="hour in hourOptions">{{hour.title}}</option>
                </select>
            </div> -->
      </flex-cell>
      <flex-cell shrink>
        <div class="date-section shrink">:</div>
      </flex-cell>
      <flex-cell shrink>
        <native-select
          @touched="touched"
          v-model="minute"
          :field="{ minimum: 1, maximum: 1, options: minuteOptions }"
        >
          <div class="date-section">
            {{ displayMinute }}
            <ux-icon right icon="fa-angle-down" />
          </div>
        </native-select>
        <!-- <div class="custom-select">
                <select v-model="minute">
                    <option :value="minute.value" v-for="minute in minuteOptions">{{minute.title}}</option>
                </select>
            </div> -->
      </flex-cell>
      <flex-cell shrink class="last">
        <native-select
          @touched="touched"
          v-model="meridianGate"
          :field="{ minimum: 1, maximum: 1, options: amOptions }"
        >
          <div class="date-section">
            {{ meridian }}
            <ux-icon right icon="fa-angle-down" />
          </div>
        </native-select>
        <!-- <div class="custom-select">
                <select v-model="meridian">
                    <option :value="ampm.value" v-for="ampm in amOptions">{{ampm.title}}</option>
                </select>
            </div> -->
      </flex-cell>

      <flex-cell class="spacer" />
    </template>
    <flex-cell shrink class="first">
      <native-select
        @touched="touched"
        v-model="day"
        :field="{ minimum: 1, maximum: 1, options: dayOptions }"
      >
        <div class="date-section">
          {{ displayDay }}
          <ux-icon right icon="fa-angle-down" />
        </div>
      </native-select>
      <!-- <div class="custom-select">
                <select v-model="day">
                    <option :value="day.value" v-for="day in dayOptions">{{day.title}}</option>
                </select>
            </div> -->
    </flex-cell>
    <flex-cell shrink>
      <native-select
        @touched="touched"
        v-model="month"
        :field="{ minimum: 1, maximum: 1, options: monthOptions }"
      >
        <div class="date-section">
          {{ displayMonth }}
          <ux-icon right icon="fa-angle-down" />
        </div>
      </native-select>
      <!-- <div class="custom-select">
                <select v-model="month">
                    <option :value="month.value" v-for="month in monthOptions">{{month.title}}</option>
                </select>
            </div> -->
    </flex-cell>
    <flex-cell shrink class="last">
      <div class="custom-select">
        <!-- <select v-model="year">
                    <option :value="year.value" v-for="year in yearOptions">{{year.title}}</option>
                </select> -->
        <native-select
          @touched="touched"
          v-model="year"
          :field="{ minimum: 1, maximum: 1, options: yearOptions }"
        >
          <div class="date-section">
            {{ displayYear }}
            <ux-icon right icon="fa-angle-down" />
          </div>
        </native-select>
      </div>
    </flex-cell>
    <!-- <flex-cell shrink>
            <select v-model="model.month">
                <option v-for="month in monthOptions">{{month}}</option>
            </select>
        </flex-cell>
        <flex-cell shrink>
            <select v-model="model.year">
                <option v-for="year in yearOptions">{{year}}</option>
            </select>
        </flex-cell> -->
  </flex-row>
</template>
<script>
import { DateTime } from "luxon";
import _range from "lodash/range";
import _debounce from "lodash/debounce";
import NativeSelect from "./select.vue";

function zero(input) {
  if (String(input).length < 2) {
    input = `0${input}`;
  }
  return input;
}

const { lookup: monthLookup, options: monthOptions } = [
  ..._range(1, 13),
].reduce(
  function (memo, m) {
    let title;
    switch (m) {
      case 1:
        title = "January";
        break;
      case 2:
        title = "February";
        break;
      case 3:
        title = "March";
        break;
      case 4:
        title = "April";
        break;
      case 5:
        title = "May";
        break;
      case 6:
        title = "June";
        break;
      case 7:
        title = "July";
        break;
      case 8:
        title = "August";
        break;
      case 9:
        title = "September";
        break;
      case 10:
        title = "October";
        break;
      case 11:
        title = "November";
        break;
      case 12:
        title = "December";
        break;
    }

    memo.lookup[m] = title;
    memo.options.push({
      title,
      value: m,
    });

    return memo;
  },
  {
    lookup: {},
    options: [],
  },
);

function createDefaultDate() {
  const defaultDate = DateTime.now().toObject();
  defaultDate.millisecond = 0;
  defaultDate.second = 0;
  defaultDate.minute = 0;
  defaultDate.hour = 12;
  return defaultDate;
}

export default {
  components: {
    NativeSelect,
  },
  props: {
    allDay: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: Object,
      default() {
        return createDefaultDate();
      },
    },
  },
  data() {
    return {
      model: undefined,
      meridian: "PM",
      disableEmit: false,
      empty: false,
    };
  },
  methods: {
    touched() {
      this.empty = false;
    },
    reset() {
      this.disableEmit = true;
      this.meridian = "PM";
      this.model = createDefaultDate();
      this.$nextTick(function () {
        this.disableEmit = false;
        this.empty = true;
      });
    },
    outputUpdate() {
      if (!this.disableEmit) {
        this.$emit("update:modelValue", this.output);
      }
    },
  },
  watch: {
    changeString: "outputUpdate",
    modelValue: {
      immediate: true,
      handler(m) {
        m = JSON.parse(JSON.stringify(m));
        if (!m) {
          this.reset();
          return;
        }

        this.empty = false;

        let inputHour = m.hour;
        let meridian = this.meridian;

        if (inputHour >= 12) {
          meridian = "PM";
          if (inputHour > 12) {
            inputHour = inputHour - 12;
          }
        } else if (inputHour < 12) {
          meridian = "AM";
        }

        this.meridian = meridian;
        m.hour = inputHour;
        this.model = m;
      },
    },
  },
  computed: {
    showTime() {
      return !this.allDay;
    },
    changeString() {
      return JSON.stringify(this.output);
    },
    output() {
      if (!this.model) {
        return;
      }

      const minute = this.showTime ? this.minute : 0;
      const hour = this.showTime ? this.actualHour : 0;

      return {
        millisecond: 0,
        second: 0,
        minute,
        hour,
        day: this.day,
        month: this.month,
        year: this.year,
        meridian: this.meridian,
      };
    },
    displayHour() {
      const self = this;
      if (self.empty) {
        return "--";
      }

      let hour = self.hour;
      if (hour === 0) {
        hour = 12;
      }

      return hour;
    },
    displayDay() {
      const self = this;
      if (self.empty) {
        return "--";
      }

      return self.day;
    },
    displayMonth() {
      const self = this;
      if (self.empty) {
        return "-";
      }

      return monthLookup[self.month];
    },
    displayYear() {
      const self = this;
      if (self.empty) {
        return "----";
      }

      return self.year;
    },
    displayMinute() {
      const self = this;
      if (self.empty) {
        return "--";
      }

      return zero(self.minute);
    },
    meridianGate: {
      get() {
        return this.meridian;
      },
      set(m) {
        this.meridian = m;
      },
    },
    hour: {
      get() {
        return this.model.hour || 0;
      },
      set(v) {
        this.model.hour = v;
      },
    },
    minute: {
      get() {
        let input = this.model.minute || 0;
        input = Math.min(input, 59);
        input = Math.max(input, 0);

        return input;
      },
      set(v) {
        this.model.minute = v;
      },
    },
    day: {
      get() {
        return this.model.day || DateTime.now().toObject().day;
      },
      set(v) {
        this.model.day = v;
      },
    },
    month: {
      get() {
        return this.model.month || DateTime.now().toObject().month;
      },
      set(v) {
        this.model.month = v;
      },
    },
    year: {
      get() {
        return this.model.year || new Date().getFullYear();
      },
      set(v) {
        this.model.year = v;
      },
    },
    actualHour() {
      const self = this;
      let hour = self.hour;

      switch (self.meridian) {
        case "AM":
          if (hour === 12) {
            return 0;
          }
          break;
        case "PM":
          if (hour === 12) {
            return 12;
          }
          hour = 12 + hour;
          break;
      }

      // hour = Math.min(hour, 23);
      return hour;
    },
    // date() {
    //     const self = this;
    //     let milliseconds = 0;
    //     let seconds = 0;
    //     let minute = self.minute;
    //     let hour = self.actualHour;
    //     let day = self.day;
    //     let month = self.month;
    //     let year = self.year;

    //     const input = {
    //         hour,
    //         minute,
    //         day,
    //         month,
    //         year,
    //         milliseconds,
    //         seconds,
    //     }

    //     return DateTime.fromObject(input)
    // },
    hourOptions() {
      return [
        { title: "1", value: 1 },
        { title: "2", value: 2 },
        { title: "3", value: 3 },
        { title: "4", value: 4 },
        { title: "5", value: 5 },
        { title: "6", value: 6 },
        { title: "7", value: 7 },
        { title: "8", value: 8 },
        { title: "9", value: 9 },
        { title: "10", value: 10 },
        { title: "11", value: 11 },
        { title: "12", value: 0 },
      ];
    },
    minuteOptions() {
      return [
        { title: "00", value: 0 },
        { title: "05", value: 5 },
        { title: "10", value: 10 },
        { title: "15", value: 15 },
        { title: "20", value: 20 },
        { title: "25", value: 25 },
        { title: "30", value: 30 },
        { title: "35", value: 35 },
        { title: "40", value: 40 },
        { title: "45", value: 45 },
        { title: "50", value: 50 },
        { title: "55", value: 55 },
      ];
      return [..._range(0, 60)].map(function (m) {
        let title = zero(m);
        return {
          title,
          value: m,
        };
      });
    },
    dayOptions() {
      return [..._range(1, 32)].map(function (m) {
        let title = m;
        return {
          title,
          value: m,
        };
      });
    },
    yearOptions() {
      var now = new Date().getFullYear();
      var min = now - 100;
      var max = now + 20;
      var years = [];

      for (var i = min; i < max; i++) {
        years.push({ title: i, value: i });
      }
      return years;
    },

    monthOptions() {
      return monthOptions;
    },
    amOptions() {
      return [
        {
          title: "AM",
          value: "AM",
        },
        {
          title: "PM",
          value: "PM",
        },
      ];
    },
    // minuteOptions() {
    //  return [..._range(0, 60)].map(function(m) {
    //         let title = String(m);
    //         if (title.length < 2) {
    //             title = `0${m}`
    //         }
    //         return {
    //             title,
    //             value: m,
    //         }
    //     }),
    // },
    timezone() {
      return "Australia/Melbourne";
    },
    // model: {
    //     get() {
    //         return {
    //             date: this.model.getDate(),
    //             month: this.model.getMonth(),
    //             year: this.model.getFullYear(),
    //             hour: this.model.getHours(),
    //             minute: this.model.getMinutes(),
    //             second: 0,
    //             millisecond: 0,
    //             timezone: this.timezone,
    //         }
    //     },
    //     set(obj) {

    //         const zone = undefined;

    //         this.model = DateTime.fromObject({
    //             ...obj,
    //             second: 0,
    //             millisecond: 0,
    //         }, { zone: this.timezone }).toJSDate();
    //     }

    // },
  },
};
</script>
<style lang="scss" scoped>
.date-section {
  padding: 0.7em 0.5em;
  // background: rgba(#000, 0.05);

  background: color-mix(in lab, currentColor 8%, transparent);
  // color: color-mix(in lab, currentColor 70%, transparent);

  min-width: 0.5em;
  text-align: center;

  // border-right: 1px solid rgba(#000, 0.1);

  .ux-icon {
    opacity: 0.3;
    font-size: 0.6em;
    margin: 0;
    display: none;
  }

  &.shrink {
    min-width: none;
    padding-left: 0;
    padding-right: 0;
  }
}

.native-select:focus-within {
  outline: 1px solid var(--primary);
}

.native-select:hover .date-section {
  background: rgba(#000, 0.07);
}

.spacer {
  flex: none;
  width: 1em;
}

.first .date-section {
  border-radius: 0.4em 0 0 0.4em;
  padding-left: 0.7em;
}

.last .date-section {
  border-radius: 0 0.4em 0.4em 0;
  padding-right: 0.7em;
}
</style>
